import React, { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router";

interface AuthGuardProps {
  component: ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ component }) => {
  const [status, setStatus] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    checkToken();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkToken = async () => {
    const token = localStorage.getItem("token");

    if (token === null) {
      navigate("/login");
      return;
    }

    setStatus(true);
  };

  return status ? (
    <React.Fragment>{component}</React.Fragment>
  ) : (
    <React.Fragment></React.Fragment>
  );
};

export default AuthGuard;
